module.exports = __webpack_public_path__ + "img/spm.1e97e8d7.svg";